var _circle, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisteredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7902_20953)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#0048B6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7902_20953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7902_20953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1625 38.5073L36.4441 29.2253L34.5462 27.3274L27.1354 34.7378L23.4271 31.0296L21.5559 32.9003L27.1625 38.5073ZM19.0386 45.625C18.1545 45.625 17.4062 45.3188 16.7938 44.7062C16.1813 44.0938 15.875 43.3455 15.875 42.4614V15.5386C15.875 14.6545 16.1813 13.9062 16.7938 13.2938C17.4062 12.6813 18.1545 12.375 19.0386 12.375H32.9375L42.125 21.5625V42.4614C42.125 43.3455 41.8188 44.0938 41.2063 44.7062C40.5938 45.3188 39.8455 45.625 38.9614 45.625H19.0386ZM31.625 22.875V15H19.0386C18.9038 15 18.7804 15.0561 18.6684 15.1684C18.5561 15.2804 18.5 15.4038 18.5 15.5386V42.4614C18.5 42.5962 18.5561 42.7196 18.6684 42.8316C18.7804 42.9439 18.9038 43 19.0386 43H38.9614C39.0962 43 39.2196 42.9439 39.3316 42.8316C39.4439 42.7196 39.5 42.5962 39.5 42.4614V22.875H31.625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7902_20953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredIcon);
export default __webpack_public_path__ + "static/media/registered-icon.992598028392f03d8ab122212d8edb8c.svg";
export { ForwardRef as ReactComponent };